import React from "react";
import { Eyebrow } from "./ui";

/* Les règles de la fiche TAS : les 9 codes officiels et ce qu'ils veulent dire.
   Aucun mapping cours par cours ici — le code retenu se règle dans la table du dessus. */
export function ReglesTas({ tas }) {
  if (!tas) return null;
  return (
    <div className="bg-white rounded-2xl p-5 border" style={{ borderColor: "var(--border)" }} data-testid="tas-codes">
      <Eyebrow>Les 9 codes de la fiche TAS</Eyebrow>
      <p className="text-xs text-[var(--muted)] mt-1">
        Codes officiels du tarif 595, en vigueur dès le {tas.en_vigueur}. {tas.unite_ecole}
      </p>
      <div className="grid sm:grid-cols-3 gap-x-6 gap-y-1.5 mt-3">
        {tas.codes.map((c) => (
          <div key={c.code} className="flex gap-2 text-xs">
            <span className="font-semibold tabular-nums" style={{ color: c.unite === "mois" ? "var(--primary)" : "var(--muted)" }}>{c.code}</span>
            <span className="text-[var(--muted)]">{c.libelle}</span>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-[var(--muted)] mt-3">
        En turquoise : les codes « par mois », ceux que l'école utilise puisqu'elle vend au semestre.
        Le hip-hop est une catégorie à part — sa couverture varie d'un assureur à l'autre.
      </p>
    </div>
  );
}

/* Comment fonctionne un forfait, en une carte : le reste (prix, costume, cours rattachés,
   nombre d'entraînements) se règle juste au-dessus. */
export function AnalyseForfaits({ analyse }) {
  return (
    <div className="bg-white rounded-2xl p-5 border" data-testid="forfaits-analyse"
      style={{ borderColor: "var(--border)" }}>
      <Eyebrow>Comment fonctionne un forfait</Eyebrow>
      <ul className="mt-3 grid md:grid-cols-2 gap-x-6 gap-y-2 text-[11px]" style={{ color: "var(--muted)" }}>
        {(analyse.aujourdhui || []).map((p) => (
          <li key={p} className="flex gap-2">
            <span style={{ color: "var(--primary)" }}>▸</span><span>{p}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
